import { createSelector } from '@reduxjs/toolkit';

import { IStore2, UserPageOptions } from 'types';
import { getDefaultAvatar } from '../user/helper';

const groupsSelector = (state: IStore2) => state.profile.groups;

const profileUserIdSelector = (state: IStore2) => state.profile.userId;

const avatarSelector = (state: IStore2) => state.profile.avatar;

const shopUserIdSelector = (state: IStore2) => state.shop.details?.userId;

const searchResultUserIdSelector = (state: IStore2) => state.searchResult.userId;

const defaultAvatarSelector = createSelector(
  [avatarSelector, profileUserIdSelector],
  (avatar, userId) => {
    if (!avatar) {
      return getDefaultAvatar(userId || '');
    }

    return avatar;
  },
);

const userPageTypeSelector = createSelector(
  [profileUserIdSelector, shopUserIdSelector, searchResultUserIdSelector],
  (profileUserId, shopUserId, searchResultsUserId) => {
    const userPageId = window.location.pathname.split('/')[2];

    if (userPageId === profileUserId) {
      return UserPageOptions.Profile;
    }
    if (userPageId === shopUserId) {
      return UserPageOptions.Shop;
    }

    if (searchResultsUserId === userPageId) {
      return UserPageOptions.SearchResults;
    }

    return UserPageOptions.None;
  },
);

export const ProfileSelector = {
  groupsSelector,
  defaultAvatarSelector,
  userPageTypeSelector,
  shopUserIdSelector,
};
